import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { IPaymentTransactionSearch } from "../../screens/payment-transaction/PaymentTransactionViewController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export const GET_ALL_PAYMENT_TRANSACTION = (
  pagination: IPagination,
  search: string,
  advanceSearch: IPaymentTransactionSearch
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_payment_transaction.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${advanceSearch.firmId ? `&firm_id=${advanceSearch.firmId}` : ""}${
        advanceSearch.fromDate ? `&from_date=${advanceSearch.fromDate}` : ""
      }${advanceSearch.toDate ? `&to_date=${advanceSearch.toDate}` : ""}${
        advanceSearch.entityType
          ? `&entity_type=${advanceSearch.entityType}`
          : ""
      }${
        advanceSearch.pgOrder
          ? `&pg_order_id=${encodeURIComponent(advanceSearch.pgOrder)}`
          : ""
      }${
        advanceSearch.entityName
          ? `&entity_name=${encodeURIComponent(advanceSearch.entityName)}`
          : ""
      }${
        advanceSearch.paymentTransactionStatus
          ? `&payment_transaction_status=${advanceSearch.paymentTransactionStatus}`
          : ""
      }${
        advanceSearch.invoiceNumber
          ? `&invoice_number=${encodeURIComponent(advanceSearch.invoiceNumber)}`
          : ""
      }`,
    API_ENDPOINTS.get_all_payment_transaction.method
  );
